import {match} from 'ts-pattern';

import type {QueryFilterObject} from 'features/eag-grid';

import {FINANCING_ENDING_END_DATE_PERIOD} from '../../constants/FINANCING_ENDING_END_DATE_PERIOD';

export type FinancingEndingPreset = 'next90Days' | 'next30Days' | 'thisMonth';

// The end date of a reminder link: its data query holds the exact date, so no tab applies.
export type FinancingEndingPeriod = FinancingEndingPreset | typeof FINANCING_ENDING_END_DATE_PERIOD;

const NEXT_90_DAYS_COUNT = 90;
const NEXT_30_DAYS_COUNT = 30;

// Every tab sets its end date: a tab click saves its query as the default view of the user.
export function getFinancingEndingPresetFilter(
  period: FinancingEndingPeriod,
  filter: QueryFilterObject
): QueryFilterObject {
  return match(period)
    .with(FINANCING_ENDING_END_DATE_PERIOD, () => filter)
    .with('next90Days', () => ({
      ...filter,
      endOfFinancing: {relativeInputKey: 'NEXT_N_DAYS', relativeInputValue: NEXT_90_DAYS_COUNT},
    }))
    .with('next30Days', () => ({
      ...filter,
      endOfFinancing: {relativeInputKey: 'NEXT_N_DAYS', relativeInputValue: NEXT_30_DAYS_COUNT},
    }))
    .with('thisMonth', () => ({...filter, endOfFinancing: 'THIS_MONTH'}))
    .exhaustive();
}
